import { Component, OnInit } from '@angular/core';
import {isNullOrUndefined} from 'util';
import {GlobalDataService} from '../global-data.service';
import {Router} from '@angular/router';
import {LoginService} from '../login.service';

@Component({
  selector: 'app-skyswitch-login',
  templateUrl: './skyswitch-login.component.html',
  styleUrls: ['./skyswitch-login.component.css']
})
export class SkySwitchLoginComponent implements OnInit {

  private username = '';
  private password = '';
  private loginError: string;

  constructor(private loginService: LoginService, private globalDataService: GlobalDataService, private router: Router) { }

  ngOnInit() {
  }

  onSubmit() {
    if (this.username !== '' && this.password !== '') {
      this.loginService.loginSkyswitch(this.username, this.password)
        .then(this.updateSession.bind(this))
        .catch(this.handleLoginError.bind(this));
    } else {
      this.loginError = 'Username and Password are required.';
    }
  }

  handleLoginError(e) {
    const jsonError = JSON.parse(e._body);
    if (!isNullOrUndefined(jsonError.sub_status)) {
      this.loginError = jsonError.message;
    } else {
      this.loginError = 'The server encountered an error.  If the problem persists, contact your system admin.';
    }
  }

  updateSession(result) {
    this.globalDataService.loginType = 'skyswitch';
    this.globalDataService.token = result.token;
    this.globalDataService.refreshToken = result.refresh_token;
    this.globalDataService.skyLogin = result.sky_login;
    this.globalDataService.role = result.role;
    this.router.navigate(['/create/order']);
  }

}



// WEBPACK FOOTER //
// ./src/app/skyswitch-login/skyswitch-login.component.ts